import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=22d719b3&scoped=true"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"
import style0 from "./BottomMenu.vue?vue&type=style&index=0&id=22d719b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d719b3",
  null
  
)

export default component.exports